import { render, staticRenderFns } from "./AudioAttribute.vue?vue&type=template&id=0050bf92&scoped=true"
import script from "./AudioAttribute.vue?vue&type=script&lang=js"
export * from "./AudioAttribute.vue?vue&type=script&lang=js"
import style0 from "./AudioAttribute.vue?vue&type=style&index=0&id=0050bf92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050bf92",
  null
  
)

export default component.exports